<div id="sketchTool" class="lasso-tool" #sketchTool></div>